module.exports = __webpack_public_path__ + "static/media/service-img-01.478c415a.png";